<template>
  <div class="w-full flex flex-col justify-center items-center mx-auto mb-8">
    <h2 class="font-bold text-xl md:text-2xl text-center mb-2">{{ title }}</h2>
    <p class="text-slate-600 text-sm md:text-base text-center">{{ subTitle }}</p>
  </div>
</template>
<script>
export default {
  name: 'TitleComponent',
  props: {
    title: {
      type: String,
      required: true
    },
    subTitle: {
      type: String,
      required: true
    }
  }
}
</script>